import { TExtra } from '../../types/analytics';
import { IApplicationState } from '../../types/redux';
import { INewbuildingBuilder } from '../../types/newbuilding/builder';
import { newbuildingIdSelector } from '../newbuildingIdSelector';

export function getProductsData(id: number, builder: INewbuildingBuilder | null, extra?: TExtra, position?: number) {
  if (!builder || !builder.phoneAnalyticsData) {
    return {
      id,
      offerType: 'JK',
      position: position || 1,
      extra,
    };
  }

  return {
    extra,
    brand: builder.phoneAnalyticsData.brand,
    nv: builder.phoneAnalyticsData.nv,
    dealType: builder.phoneAnalyticsData.dealType,
    id: builder.phoneAnalyticsData.id,
    name: builder.phoneAnalyticsData.name,
    objectType: builder.phoneAnalyticsData.objectType,
    consultant: builder.phoneAnalyticsData.consultant,
    position: builder.phoneAnalyticsData.position,
  };
}

export function selectDefaultProductsData(state: IApplicationState) {
  const newbuildingId = newbuildingIdSelector(state);

  return {
    id: newbuildingId,
    offerType: 'JK',
    position: 1,
  };
}
